module.exports = __webpack_public_path__ + "static/What_we_Offer@2x-a9fd854d9dac8929233e09d1b9e916e4.jpg";